import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import {
  CreateReachProSupportCaseRequest,
  Feature,
  ReachProSupportCaseClient,
} from 'src/WebApiController';

import { SUPPORT_CASES_QUERY_KEY } from './useReachProSupportCases';

export function useCreateReachProSupportCase() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();
  const queryClient = useQueryClient();
  const hasReachProSupportFeature = useUserHasFeature(Feature.ReachProSupport);

  return useMutation({
    mutationFn: async (request: CreateReachProSupportCaseRequest) => {
      if (!hasReachProSupportFeature) {
        throw new Error('Support Center feature is not enabled');
      }

      return tryInvokeApi(
        async () => {
          return await new ReachProSupportCaseClient(
            activeAccountWebClientConfig
          ).createSupportCase(request);
        },
        (error) => {
          showErrorDialog('ReachProSupportCaseClient.createSupportCase', error);
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SUPPORT_CASES_QUERY_KEY] });
    },
  });
}
